import React, { useContext } from "react";
import "./style1.css";
import MyContext from "../../InvoiceForm/Context";

// function Invoice() {
const Invoice1 = () => {
  const invoice1data = useContext(MyContext);

  const printDiv = (divID) => {
    const divElements = document.getElementById(divID).innerHTML;
    const oldPage = document.body.innerHTML;

    // Insert the content into the print window
    document.body.innerHTML = `<html>
        <head>
          <title>Print</title>
        </head>
        <body>
          ${divElements}
        </body>
      </html>`;

    // Trigger the print dialog
    window.print();

    // Restore the original page content
    document.body.innerHTML = oldPage;
  };

  const onClose = () => {
    invoice1data.setSelectedContainer(null);
    invoice1data.setForceRerender((prev) => prev + 1); // Trigger re-render
  };

  return (
    <div>
      <div id="Invoice1print" className="invoice-container-main">
        {/* Header */}
        <div className="header">
          <div className="left-section">
            <img
              src={invoice1data.imageUrl}
              alt="Company Logo"
              style={{ height: "170px" }}
            />
          </div>
          {/* <div className="center-section">
          <h3>Invoice</h3>
        </div> */}
          <div className="right-section">
            <strong>{invoice1data.companyName}</strong>
            <br />
            {/* <strong> {invoice1data.name}</strong>
            <br /> */}
            <strong> {invoice1data.gstin}</strong>
            <br />
            <strong>{invoice1data.address}</strong>
            <br />
            <strong>{invoice1data.address2}</strong>
            <br />
            <strong>{invoice1data.city}</strong>
            <br />
            <strong>{invoice1data.state}</strong>
            <br />
            <strong>{invoice1data.country}</strong>
          </div>
        </div>

        {/* Seller and Buyer Info */}
        <div className="info-section seller-buyer">
          <div className="seller-info">
            <strong style={{ color: "black" }}>Bill To:</strong>
            <br />
            <br />
            <strong>{invoice1data.clientCompany}</strong>
            <br />
            <strong>{invoice1data.clientGstin}</strong>
            <br />
            <strong>{invoice1data.clientAddress}</strong>
            <br />
            <strong>{invoice1data.clientAddress2}</strong>
            <br />
            <strong>{invoice1data.clientCity}</strong>
            <br />
            <strong>{invoice1data.clientState}</strong>
            <br />
            <strong>{invoice1data.clientCountry}</strong>
          </div>
          {invoice1data.toggleSwitch &&  <div className="buyer-info">
            <strong style={{ color: "black" }}>Ship To:</strong>
            <br />
            <br />
            <strong>{invoice1data.shipToCompany}</strong>
            <br />
            <strong>{invoice1data.shipToGstin}</strong>
            <br />
            <strong>{invoice1data.shipToAddress}</strong>
            <br />
            <strong>{invoice1data.shipToAddress2}</strong>
            <br />
            <strong>{invoice1data.shipToCity}</strong>
            <br />
            <strong>{invoice1data.shipToState}</strong>
            <br />
            <strong>{invoice1data.shipToCountry}</strong>
            <br />
          </div>}
          <div>
            <p>
              <strong>Invoice No:{invoice1data.invoiceNumber}</strong>
            </p>
            <p>
              <strong>Invoice Date:{invoice1data.invoiceDate}</strong>
            </p>
          </div>
        </div>

        {/* Product Table */}
        <table className="product-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Quantity</th>
              <th>Rate</th>
              <th>HSN Code</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {invoice1data?.tableData?.map((data, index) => {
              // {
              //   console.log("=================>invoiceData", data);
              // }
              return (
                <tr key={index}>
                  <td>{data.description}</td>
                  <td>{data.qty}</td>
                  <td>{data.rate}</td>
                  <td>{data.hsn}</td>
                  <td> {data.amount}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3"></td>
              <td>SubTotal</td>
              <td>{invoice1data.subTotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3"></td>
              <td>SGST {invoice1data.sgst}%</td>
              <td>
                {((invoice1data.subTotal / 100) * invoice1data.sgst).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="3"></td>
              <td>CGST {invoice1data.cgst}%</td>
              <td>
                {((invoice1data.subTotal / 100) * invoice1data.cgst).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="3"></td>
              <td>GST {invoice1data.gst} %</td>
              <td>
                {(invoice1data.subTotal * (invoice1data.gst / 100)).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="4">Total Amount</td>
              <td>{invoice1data.total.toFixed(2)}</td>
            </tr>
          </tfoot>
        </table>

        {/* Footer */}
        <div className="footer">
          <div className="additional-info">
            <h4>Terms</h4>
            <div
              style={{
                minWidth: "50%",
                minHeight: "80%",
                maxWidth: "auto",
                minHeight: "auto",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              {invoice1data.terms}
            </div>
            <hr />
            <h4>Notes</h4>
            <div
              style={{
                minWidth: "100%",
                minHeight: "80%",
                maxWidth: "auto",
                minHeight: "auto",
              }}
            >
              {invoice1data.notes}
            </div>
          </div>
        </div>

        {/* Signature */}
        {/* <div className="signature">
        <p>
          <strong>Authorized Signature:</strong>
          <img src="signature.png" alt="Signature" className="signature-img" />
        </p>
      </div> */}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <section style={{ marginTop: "20px" }}>
          <button
            onClick={() => printDiv("Invoice1print")}
            style={{
              marginRight: "10px",
              background: "green",
              borderRadius: "5px",
              color: "white",
              border: "none",
              padding: "5px 10px",
            }}
          >
            Print
          </button>
          <button
            onClick={onClose}
            style={{
              marginRight: "10px",
              background: "red",
              borderRadius: "5px",
              color: "white",
              border: "none",
              padding: "5px 10px",
            }}
          >
            Close
          </button>
        </section>
      </div>
    </div>
  );
};

export default Invoice1;
